
import TeamCard from "./TeamCard";

const AboutClient = (props) => {
    const team = [
        {
            id:1,
            image:"https://placehold.co/450x350/jpg",
            //image:"https://images.pexels.com/photos/2787341/pexels-photo-2787341.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300",
            name:"Walter White",
            designation:"Front End Developer",
        },
        {
            id:2,
            image:"https://placehold.co/450x350/jpg",
            //image:"https://images.unsplash.com/photo-1569124589354-615739ae007b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
            name:"Julie Brown",
            designation:"Full Stact Developer",
        },
        {
            id:3,
            image:"https://placehold.co/450x350/jpg",
            //image:"https://images.unsplash.com/photo-1595072009558-430d78d6bf3b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=600&q=80",
            name:"Rose Alpha",
            designation:"Director, Product Development",
        },
        {
            id:4,
            image:"https://placehold.co/450x350/jpg",
            //image:"https://images.unsplash.com/photo-1595102298291-82c1014f413a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=600&q=80",
            name:"Rosanna Pattie",
            designation:"Head of Operations",
        },
        {
            id:5,
            image:"https://placehold.co/450x350/jpg",
            //image:"https://images.unsplash.com/photo-1595072009558-430d78d6bf3b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=60",
            name:"Dora Caelan",
            designation:"Hr-manager",
        },
        {
            id:6,
            image:"https://placehold.co/450x350/jpg",
            //image:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
            name:"Suzan Lois",
            designation:"Graphic Designer",
        },
        {
            id:6,
            image:"https://placehold.co/450x350/jpg",
            //image:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
            name:"Ian Bailey",
            designation:"Head of Development",
        },
        {
            id:6,
            image:"https://placehold.co/450x350/jpg",
            //image:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60",
            name:"Anne Smith",
            designation:"Graphic Designer",
        }
    ];
    return (
        <div className={`${props.className} row`}>
            {team && 
                team.map((item,index) =>
                    <TeamCard 
                        key={item.id}
                        item={item}
                    />
                )  
            }
            
            
        </div>
    );
};

export default AboutClient;